import React from "react";
import type { ToggleControlModel } from "../../type/toggleControl";
import "./toggleControl.scss";

const ToggleControl: React.FC<ToggleControlModel> = ({
  checked,
  onChange,
  label,
  saving = false,
  disabled = false,
  className = ""
}) => {
  return (
    <div className={`settings-item-control ${className}`}>
      {saving && (
        <span className="settings-saving-indicator">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </span>
      )}
      <div
        className={`settings-toggle ${checked ? "active" : ""} ${disabled ? "disabled" : ""}`}
        onClick={disabled ? undefined : onChange}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        aria-disabled={disabled}
        style={{ opacity: saving || disabled ? 0.6 : 1 }}
      >
        <div className="settings-toggle-thumb"></div>
      </div>
    </div>
  );
};

export default ToggleControl;